'use strict';

import TextField from './Text';

class SystemField extends TextField {
}

export default SystemField;
